//
//
//
//
//
//

export default {
	props: ["id", "Data", "name"],
	data() {
		return {
			legendName: [],
		};
	},
	mounted() {
		setTimeout(() => {
			this.drawLine();
		}, 1000);
	},
	watch: {

		Data() {
			this.drawLine();
		}
	},
	methods: {
		fontSize(res) {
			let docEl = document.documentElement,
				clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (!clientWidth) return;
			let fontSize = 100 * (clientWidth / 1920);
			// alert(fontSize)
			return res * fontSize;
		},
		drawLine() {
			// 基于准备好的dom，初始化echarts实例
			let myChart = this.$echarts.init(document.getElementById(this.id));
			myChart.clear()
			// 绘制图表
			myChart.setOption({
				legend: {
					type: 'scroll',
					orient: 'vertical',
					right: '14%',
					y: 'center',
					itemGap: 10,
					icon: "circle",

					data: ['非常满意', '满意', '基本满意', '不满意', '非常不满意'],
					textStyle: { //图例文字的样式
						color: 'rgba(165,195,252,1)',
						fontSize: this.fontSize(0.16)
						// fontSize:'0.36rem'
					}
				},
				grid: {
					top: '0%',
					left: '0%',
					right: '0%',
					bottom: '0%',
					containLabel: true
				},
				tooltip: {
					formatter: "{a} <br/>{b} : {c} ({d}%)"
				},
				series: [{
					name: '整体满意度',
					type: 'pie',
					radius: ['20%', '56%'],
					center: ['36.2%', '49%'],
					roseType: 'radius',
					label: {
						normal: {
							show: true,
							formatter: '{d}%'
						},
						emphasis: {
							show: true
						}
					},
					color: ['#F64D4A', '#FF8B2E', '#FAC028', '#9ecd1f', '#12B376'],
					lableLine: {
						normal: {
							show: true
						},
						emphasis: {
							show: true
						}
					},
					data: this.Data
				}]
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/rose.vue